import type { HeliaNode, FileMetadata } from "@/types/poc/helia";

export interface FileExistsResult {
  exists: boolean;
  cid: string;
}

export interface FileDataResult {
  cid: string;
  data: Uint8Array;
  size: number;
}

export interface GetFileDataOptions {
  signal?: AbortSignal;
  onChunkReceived?: (bytesLoaded: number) => void;
}

export abstract class NetworkFileService {
  /**
   * Pure check if file exists in Helia node
   */
  abstract checkFileExists(heliaNode: HeliaNode, cid: string): Promise<FileExistsResult>;

  /**
   * Pure file data retrieval from Helia
   */
  abstract getFileData(heliaNode: HeliaNode, cid: string, options?: GetFileDataOptions): Promise<FileDataResult>;

  /**
   * Pure metadata creation
   */
  abstract createFileMetadata(cid: string, size: number, sixId:string, providedMetadata?: FileMetadata): FileMetadata;

  /**
   * Pure filesystem save operation
   */
  abstract saveToFilesystem(data: Uint8Array, filename: string, mimeType?: string): void;
}
